import { HomeFilled, UserFilled, Setting, SetUp, User, Phone, Timer, Picture, Iphone, UploadFilled, ChatDotRound, Connection, DataBoard, List, Monitor, Location } from '@element-plus/icons-vue'
import type { RouteRecordRaw } from 'vue-router'
import MdiArrowULeftBottomBold from '~icons/mdi/arrow-u-left-bottom-bold'
import MdiHelpCircle from '~icons/mdi/help-circle'
import MdiWidgets from '~icons/mdi/widgets'

import AZAN_ICON from "@/assets/images/AZAN_icon.svg"
import RouteNames from './route-names'

/**
 * - path 路由路径
 * - name 路由名称，禁止使用硬编码，请将名称定义到 RouteNames 变量中
 * - component 路由组件
 * - children 子路由
 * - meta 自定义元数据
 * - meta.label: string 路由的标题，用于展示在菜单栏和面包屑
 * - meta.icon: Component 路由的图标，用于展示在菜单栏和面包屑
 * - meta.hide: boolean = false 表示该路由是否展示在菜单栏中
 */
export const routes: RouteRecordRaw[] = [
  {
    path: 'home',
    name: RouteNames.Home,
    component: () => import('@/views/home/index.vue'),
    meta: { label: '首页', icon: HomeFilled, static: true },
  },
  // {
  //   path: 'setting',
  //   name: RouteNames.Setting,
  //   meta: { label: '设置', icon: Setting, static: true },
  //   children: [
  //     {
  //       path: 'user',
  //       name: RouteNames.Setting_User,
  //       component: () => import('@/views/setting/user/index.vue'),
  //       meta: { label: '账号设置', icon: SetUp, static: true },
  //     },
  //     {
  //       path: 'Role',
  //       name: RouteNames.Setting_Role,
  //       component: () => import('@/views/setting/role/index.vue'),
  //       meta: { label: '角色设置', icon: User, static: true },
  //     },
  //   ],
  // },
  {
    path: 'azan',
    name: RouteNames.Azan,
    meta: { label: 'AZAN', icon: Setting, static: true },
    children: [
      // {
      //   path: 'ring',
      //   name: RouteNames.Azan_Ring,
      //   component: () => import('@/views/azan/ring/index.vue'),
      //   meta: { label: 'AZAN铃声', icon: Phone, static: true },
      // },
      // {
      //   path: 'time',
      //   name: RouteNames.Azan_Time,
      //   component: () => import('@/views/azan/time/index.vue'),
      //   meta: { label: '各国 AZAN 时间', icon: Timer, static: true },
      // },
      {
        path: 'regions',
        name: RouteNames.Azan_Regions,
        component: () => import('@/views/azan/regions/index.vue'),
        meta: { label: '地区代码管理', icon: Location, static: true },
      },
      {
        path: 'prayer-times',
        name: RouteNames.Azan_PrayerTimes,
        component: () => import('@/views/azan/prayer-times/index.vue'),
        meta: { label: '礼拜时间管理', icon: Timer, static: true },
      },
      // {
      //   path: 'prayer',
      //   name: RouteNames.Azan_Prayer,
      //   component: () => import('@/views/azan/prayer/index.vue'),
      //   meta: { label: '祷告人图像', icon: Picture, static: true },
      // }
    ]
  },
  {
    path: 'app',
    name: RouteNames.App,
    meta: { label: 'app 管理', icon: Iphone, static: true },
    children: [{
      path: 'user',
      name: RouteNames.App_User,
      component: () => import('@/views/app/user/index.vue'),
      meta: { label: '用户管理', icon: User, static: true },
    }, {
      path: 'equipment',
      name: RouteNames.App_Equipment,
      component: () => import('@/views/app/equipment/index.vue'),
      meta: { label: '用户设备', icon: Connection, static: true },
    },

    {
      path: 'software',
      name: RouteNames.App_Software,
      component: () => import('@/views/app/software/index.vue'),
      meta: { label: '固件管理', icon: UploadFilled, static: true },
    },
    {
      path: 'feedback',
      name: RouteNames.App_Feedback,
      component: () => import('@/views/app/feedback/index.vue'),
      meta: { label: 'app 反馈', icon: ChatDotRound, static: true },
    },
    {
      path: 'tasks',
      name: RouteNames.App_Tasks,
      component: () => import('@/views/app/tasks/index.vue'),
      meta: { label: '任务管理', icon: List, static: true },
    },
    {
      path: 'counts',
      name: RouteNames.App_Counts,
      component: () => import('@/views/app/counts/index.vue'),
      meta: { label: '计数管理', icon: DataBoard, static: true },
    },
    ]
  },
  {
    path: 'dashboard',
    name: RouteNames.Dashboard,
    component: () => import('@/views/dashboard/index.vue'),
    meta: { label: '数据仪表板', icon: Monitor, static: true },
  },
  // {
  //   path: 'mine',
  //   name: RouteNames.Mine,
  //   meta: { label: '个人中心', icon: UserFilled, static: true },
  //   redirect: { name: RouteNames.My_Info },
  //   children: [
  //     {
  //       path: 'messages',
  //       name: RouteNames.My_Messages,
  //       component: () => import('@/views/mine/message/index.vue'),
  //       meta: { label: '消息提醒', static: true },
  //     },
  //   ],
  // },

  // 以下的都要删除
  // {
  //   path: 'components-demo',
  //   name: RouteNames.ComponentDemo,
  //   meta: { label: '组件', icon: MdiWidgets },
  //   children: [
  //     {
  //       path: 'base',
  //       name: RouteNames.ComponentDemo_Base,
  //       component: () => import('@/views/components-demo/base/index.vue'),
  //       meta: {
  //         label: '基础组件',
  //       },
  //     },
  //     {
  //       path: 'json-editor',
  //       name: RouteNames.ComponentDemo_JsonEditor,
  //       component: () => import('@/views/components-demo/json-editor-demo.vue'),
  //       meta: {
  //         label: 'JSON 编辑器',
  //       },
  //     },
  //     {
  //       path: 'diff-html',
  //       name: RouteNames.ComponentDemo_DiffText,
  //       component: () => import('@/views/components-demo/diff-text-demo.vue'),
  //       meta: {
  //         label: '文案差异展示',
  //       },
  //     },
  //     {
  //       path: 'table',
  //       name: RouteNames.ComponentDemo_Table,
  //       component: () => import('@/views/components-demo/table-demo.vue'),
  //       meta: {
  //         label: '表格组件',
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: 'multi-level-menu',
  //   name: RouteNames.MultiLevelMenu,
  //   meta: { label: '多级菜单', icon: MdiArrowULeftBottomBold },
  //   children: [
  //     {
  //       path: 'level1',
  //       name: RouteNames.MultiLevelMenu_Level1,
  //       meta: {
  //         label: '一级菜单',
  //       },
  //       children: [
  //         {
  //           path: 'level2',
  //           name: RouteNames.MultiLevelMenu_Level2,
  //           meta: {
  //             label: '二级菜单',
  //           },
  //           children: [
  //             {
  //               path: 'level3',
  //               name: RouteNames.MultiLevelMenu_Level3,
  //               meta: {
  //                 label: '三级菜单',
  //               },
  //               component: () => import('@/views/multi-level-menu/index.vue'),
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   path: 'guidance',
  //   name: RouteNames.Guidance,
  //   component: () => import('@/views/guidance/index.vue'),
  //   meta: { label: '使用指南', icon: MdiHelpCircle },
  // },

  // 以下页面不在侧边栏显示
  {
    path: 'split-screen',
    name: RouteNames.SplitScreen_Redirect,
    component: () => import('@/views/split-screen/redirect/index.vue'),
    meta: { hide: true },
  },
]

// 通过一定规则匹配路由
export const filterRoutes = (
  routes: RouteRecordRaw[],
  cb: (route: RouteRecordRaw) => boolean,
) => {
  const result: RouteRecordRaw[] = []

  for (const route of routes) {
    const _route = { ...route }
    if (_route.children?.length) {
      _route.children = filterRoutes(_route.children, cb)
      if (_route.children.length) {
        result.push(_route)
      }
    } else {
      if (cb(route)) {
        result.push(_route)
      }
    }
  }

  return result
}

export const getMenuRoutes = () => {
  return filterRoutes(routes, (route) => {
    if (route.meta!.hide) {
      return false
    }

    if ((route.name as string).includes(RouteNames.DevTools)) {
      return false
    }

    return true
  })
}
